export default __webpack_public_path__ + "static/media/successTick.6d967b3e.png";